<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 124 109" fill="none">
    <g clip-path="url(#clip0_40002919_5413)">
      <path
        d="M52.8667 6.46968C56.3916 -1.4313 67.6065 -1.4313 71.1314 6.46968L108.587 90.4254C111.538 97.0397 106.697 104.5 99.4546 104.5H24.5435C17.3009 104.5 12.4603 97.0397 15.4112 90.4254L52.8667 6.46968Z"
        fill="#83868A"
      />
      <rect x="0.953613" y="90.1367" width="122.091" height="17.9545" rx="8.97727" fill="#252525" />
      <mask
        id="mask0_40002919_5413"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="14"
        y="0"
        width="96"
        height="105"
      >
        <path
          opacity="0.75"
          d="M52.8662 6.46968C56.3911 -1.4313 67.6061 -1.4313 71.131 6.46968L108.586 90.4254C111.537 97.0397 106.697 104.5 99.4541 104.5H24.543C17.3004 104.5 12.4598 97.0397 15.4107 90.4254L52.8662 6.46968Z"
          fill="#45C8A7"
        />
      </mask>
      <g mask="url(#mask0_40002919_5413)">
        <rect x="15.3169" y="58.7158" width="96.9545" height="18.8523" fill="#F4F5FA" />
        <rect x="15.3169" y="21.0117" width="96.9545" height="18.8523" fill="#F4F5FA" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_40002919_5413">
        <rect width="124" height="108" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
</template>
